import React from "react"
import "./App.css";
import "./bootstrap.css";
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import Page from './pages/Page';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Feedback from './pages/Feedback';
import Footer from './components/Footer'



function App() {
  return (
    <>
    <Router>

      <Navbar />
      {/* <HeroSection /> */}
      {/* <Home /> */}
      <Switch>
        <Route path='/' exact component={Home} >

        </Route>
        <Route path='/services' component={Services}></Route>
        <Route path='/blog' component={Blog}></Route>
        <Route path='/contact' component={Contact}></Route>
        <Route path='/page' component={Page}></Route>
        <Route path='/feedback' component={Feedback}></Route>
      </Switch>
    <Footer />
    </ Router>
    </>
  );
}

export default App;
